document.addEventListener('DOMContentLoaded', function () {
    const bottomBar = document.getElementById('single-product-bottom-bar');
    const body = document.querySelector('body');

    if (bottomBar) {
        const callback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    bottomBar.classList.add('invisible');
                    bottomBar.classList.add('-bottom-28');
                    bottomBar.classList.remove('bottom-0');
                } else {
                    bottomBar.classList.remove('invisible');
                    bottomBar.classList.remove('-bottom-28');
                    bottomBar.classList.add('bottom-0');
                }
            });
        };

        const observer = new IntersectionObserver(callback);
        const element = document.querySelector('.single-product-add-to-cart-button-wrap > .single_add_to_cart_button');

        observer.observe(element);

        window.addEventListener('scroll', function() {
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop + windowHeight >= documentHeight) {
                body.style.marginBottom = `${bottomBar.offsetHeight}px`;
            }
        });
    }
})